export default __webpack_public_path__ + "static/media/About-Us.5628ebb5.png";